const isFullScreen = () => {
  return (
    !!window.document.fullscreenElement ||
    !!window.document.mozFullScreenElement ||
    !!window.document.webkitFullscreenElement ||
    !!window.document.msFullscreenElement
  );
};

const FullScreen = {
  invoke: {
    toggleFullScreen() {
      const requestFullScreen =
        window.document.documentElement.requestFullscreen ||
        window.document.documentElement.mozRequestFullScreen ||
        window.document.documentElement.webkitRequestFullScreen ||
        window.document.documentElement.msRequestFullscreen;
      const cancelFullScreen =
        window.document.exitFullscreen ||
        window.document.mozCancelFullScreen ||
        window.document.webkitExitFullscreen ||
        window.document.msExitFullscreen;
      if (!isFullScreen()) {
        requestFullScreen
          .call(window.document.documentElement)
          .catch(console.error);
      } else {
        cancelFullScreen.call(window.document).catch(console.error);
      }
    },
    isFullScreen,
  },
  on: {
    onFullScreenChange(callback: Function) {
      const listener = () => callback(isFullScreen());
      window.document.documentElement.addEventListener(
        'fullscreenchange',
        listener
      );

      return () => {
        window.document.documentElement.removeEventListener(
          'fullscreenchange',
          listener
        );
      };
    },
  },
};

export default FullScreen;
